<div class="consultant">
  <img src="assets/images/consultant/sign.png" alt="consultant-sign" />
  <div class="consultant-name">Lokesh Thakare</div>
</div>
